import Vue from "vue"

const vm = new Vue()

export const getReportReceipt = async (search) => {
    return new Promise((resolve, reject) => {
        vm.$http.get(vm.$API_URL + "/admin/invoice", {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                date_start: search.date.startDate,
                date_end: search.date.endDate,
                receipt_no: search.receiptNo,
                status: search.status,
                shop_code: search.shopCode,
                sa_code: search.saCode,
                page: search.page,
                per_page: search.perPage,
                ...( search.type ) ? { type: search.type } : {}
            }
        }).then((res) => {
            let data = res.data.data

            if (!res.data.status) {
                reject(res.data.error)
            }

            resolve(data)
        })
    })
}

export const getEAccountDocumentDownloadUrl = async (invoiceId) => {
    return new Promise((resolve, reject) => {
        vm.$http.get(vm.$API_URL + `/admin/invoice/${invoiceId}/e-account`, {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                invoice_id: invoiceId
            }
        }).then((res) => {
            if (!res.data.status) {
                reject(res.data.error)
            }

            resolve(res.data.data)
        })
    })
}

export const getReportReceiptForExcel = async (search) => {
    return new Promise((resolve) => {
        let excelTask = []
        let page = 1

        for( let i = 0 ; i < search.totalPage; i++ ){
            excelTask.push( vm.$http
                .get(
                    vm.$API_URL + "/admin/invoice",
                    {
                        headers: {
                            Token: localStorage.getItem("access_token"),
                        },
                        params: {
                            date_start: search.date.startDate,
                            date_end: search.date.endDate,
                            receipt_no: search.receiptNo,
                            status: search.status,
                            shop_code: search.shopCode,
                            sa_code: search.saCode,
                            page: page++
                        }
                    }
                )
            )
        }

        Promise.all(excelTask).then( (resData) => {
            let dataExcel = [];
            resData.forEach( data => {
                dataExcel.push(...data.data.data.item)
            })
            resolve(dataExcel)
        })
    })
}
